export const shortName = (name: string) => {
  const splitedCoachName = name?.split(' ');
  if (splitedCoachName.length === 1) {
    return splitedCoachName[0];
  }
  return (`${splitedCoachName[1][0]}.${splitedCoachName[0]}`);
};
